export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/profileIcon.e9cfb59f.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};